import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=63caccb2&scoped=true&"
import script from "./BarCharts.vue?vue&type=script&lang=js&"
export * from "./BarCharts.vue?vue&type=script&lang=js&"
import style0 from "./BarCharts.vue?vue&type=style&index=0&id=63caccb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63caccb2",
  null
  
)

export default component.exports